import { render, staticRenderFns } from "./CollectionsDataSourcesSelector.vue?vue&type=template&id=ec3677b2&scoped=true"
import script from "./CollectionsDataSourcesSelector.vue?vue&type=script&lang=js"
export * from "./CollectionsDataSourcesSelector.vue?vue&type=script&lang=js"
import style0 from "./CollectionsDataSourcesSelector.vue?vue&type=style&index=0&id=ec3677b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3677b2",
  null
  
)

export default component.exports